module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_open_rate-1e76ffaf7c6fc4086334cba6c98c8075.svg";